import * as API from '../'

export default {
  /**
   * 培训资源管理:获取资料列表
   */
  getDataList: params => {
    return API.GET(`/mall/m/training/resources/data/pageList`, params)
  },
  /**
   * 培训资源管理:删除或者禁用单条资料
   */
  delData: params => {
    return API.POST(`/mall/m/training/resources/data/deleteOrAbleData`, params)
  },
  /**
   * 培训资料单条详情
   */
  getDataDetail: params => {
    return API.GET(`/mall/m/training/resources/data/getDataDetail`, params)
  },
  /**
   * 培训资料与资源保存(修改,传id)
   */
  postData: params => {
    return API.POST(`/mall/m/training/resources/data/save`, params)
  },
  /**
   * 根据培训课程id查询培训数据
   * @param params
   * @returns {Promise<*>}
   */
  queryTrainingResourcesDataByTrainingProgramId: params => {
    return API.GET(`/mall/m/training/resources/data/queryByTrainingProgramId`, params)
  },
  /**
   * 删除上传文件
   */
  deleteFile: params => {
    return API.POST(`/mall/m/training/resources/data/deleteFile`, params)
  },
  /**
   * 上传文件
   */
  // uploadFile: params => {
  //     return API.POST(`/training/resources/data/upload`, params)
  // },
  // 培训计划管理
  /**
   * 培训计划列表
   */
  getProgramList: params => {
    return API.GET(`/mall/m/training/program/pageList`, params)
  },
  coursePageList:  params => {
    return API.GET(`/mall/m/training/program/coursePageList`, params)
  },
  openCourseDetails: params => {
    return API.GET(`/mall/m/training/program/openCourseDetails`, params)
  },
  /**
   * 删除培训计划
   */
  delProgram: params => {
    return API.POST(`/mall/m/training/program/deleteProgram`, params)
  },
  /**
   * 新增培训计划
   */
  addProgram: params => {
    return API.POST(`/mall/m/training/program/save`, params)
  },
  /**
   * 培训计划详情
   */
  getProgramDetail: params => {
    return API.GET(`/mall/m/training/program/getDataDetail`, params)
  },
  /**
   * 培训计划下发
   */
  planToIssue: params => {
    return API.POST(`/mall/m/training/program/planToIssue`, params)
  },
  /**
   * 培训记录统计列表
   */
  rainingRecordPageList: params => {
    return API.GET(`/mall/m/training/record/pageList`, params)
  },

  getTrainingProgram: params => {
    return API.GET(`/mall/m/training/program/getTrainingProgram`, params)
  },
  relevanceExam: params => {
    return API.GET(`/mall/m/training/program/getExamDetail`, params)
  },
  /**
   * 查询公司列表
   * @param params
   * @returns {Promise<*>}
   */
  findImportEnterprisebaseTree: params => {
    return API.GET(`/mall/m/training/program/findImportEnterprisebaseList`, params)
  },
  /**
   * 导入课程
   * @param params
   * @returns {Promise<*>}
   */
  improtCourse: params => {
    return API.POST(`/mall/m/training/program/import`, params)
  },
  /**
   * 变更上下架状态
   * @param params
   */
  changeShelf: params => {
    return API.POST(`/mall/m/training/program/changeShelf`, params)
  },
  getOfflineList: params => {
    return API.GET(`/mall/m/training/record/offline/pageList`, params)
  },
  delRecod: params => {
    return API.POST(`/mall/m/training/record/deleteRecod`, params)
  },
  addOffline: params => {
    return API.POST(`/mall/m/training/record/offline/save`, params)
  },
  summary: params => {
    return API.POST(`/mall/m/training/record/summary/save1`, params)
  },
  getOfflineDetail: params => {
    return API.GET(`/mall/m/training/record/getDataDetail`, params)
  },
  recordOfflineExport: params => {
    return API.GETBLOB(`/mall/m/training/record/offline/export`, params)
  },
  exportSummary: params => {
    return API.GETBLOB(`/mall/m/training/record/offline/exportSummary`, params)
  },
  getSummary: params => {
    return API.GET(`/mall/m/training/record/offline/getSummary`, params)
  },
  // 师资管理
  /**
   * 师资分页列表
   */
  getTeacherList: params => {
    return API.GET(`/mall/m/tranning/teachers/pageList`, params)
  },
  /**
   * 存储师资信息
   */
  saveTeacher: params => {
    return API.POST(`/mall/m/tranning/teachers/save`, params)
  },
  /**
   * 删除师资信息
   */
  deleteTeacher: params => {
    return API.POST(`/mall/m/tranning/teachers/delete`, params)
  },
  /**
   * 教师详细信息
   */
  detailsTeacher: params => {
    return API.GET(`/mall/m/tranning/teachers/details`, params)
  },




}



// WEBPACK FOOTER //
// ./src/api/mall/training.js